import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import { Grid, InputAdornment } from '@mui/material';
import { Lock } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import { useNavigate, useParams } from 'react-router-dom';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../store/RootReducer';
import { SnackBar } from 'src/components/SnackBar';
import { resetPassword } from 'src/services/authService';
import { AppActions } from 'src/store/AppReducer';
import { Tooltip } from '@mui/material';

interface ResetPasswordFormProps {}

export const ResetPasswordForm: React.FC<ResetPasswordFormProps> = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { email } = useParams();

  const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector;
  const { isLoading } = useAppSelector((state) => state.appReducer);

  const { register, handleSubmit, setValue } =
    useForm<{ password: string; conformedPassword: string }>();

  const [passwordError, setpasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  
  function checkUppercase(str){
    for (var i=0; i<str.length; i++){
      if (str.charAt(i) === str.charAt(i).toUpperCase() && str.charAt(i).match(/[a-z]/i)){
        return true;
      }
    }
    return false;
  };

  function hasLowerCase(str) {
    return str.toUpperCase() !== str;
  }

  const changePassword = (data: {
    password: string;
    conformedPassword: string;
  }) => {
    if (data.password === '')
    {
      setpasswordError('New password is required.');
      return;
    }
    if (data.conformedPassword === '')
    {
      setConfirmPasswordError('Confirm password is required.');
      return;
    }

    if (data.password !== data.conformedPassword)
    {
      setConfirmPasswordError(
        'Confirm password does not match with the new password'
      );
      return;
    }


      var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      var hasNumber = /\d/;

      if ((data.password.length < 8) || !format.test(data.password) || !checkUppercase(data.password) || !hasNumber.test(data.password)
       || !(hasLowerCase(data.password))
      )
      {
        setConfirmPasswordError(
          'Passwords must be at least eight characters long and include at least one uppercase, one lowercase, one number and one special character.'
        );
        return;
      }


    if (
      data.password !== '' &&
      data.conformedPassword !== '' &&
      data.password === data.conformedPassword
    ) {
      dispatch(AppActions.showLoader());

      resetPassword(
        email,
        window.location.href.split(`${email}/`)[1],
        data.password,
        data.conformedPassword
      )
        .then(() => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'You’ve reset the password successfully.',
              severity: 'success'
            })
          );
          dispatch(AppActions.hideLoader());
          navigate('/');
        })
        .catch((error) => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: error.response.data,
              severity: 'error'
            })
          );
          dispatch(AppActions.hideLoader());
        });
    }
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: '100vh' }}
    >
      <Grid item xs={3}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: 3,
            width: 420,
            height: 441,
            bgcolor: 'white',
            borderRadius: 2
          }}
        >
          <Box sx={{ mt: 1 }}>
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ minHeight: '100vh' }}
            >
              <Grid item xs={12}>
                <img
                  width={156}
                  style={{ marginBottom: 25 }}
                  height={34}
                  src={process.env.PUBLIC_URL + '/img/Logo-Coloured.svg'}
                  alt={'logo'}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  textAlign={'center'}
                  color={'#21286C'}
                  fontWeight={'bold'}
                >
                  <p>Reset the Password</p>
                </Typography>
              </Grid>
              <form onSubmit={handleSubmit(changePassword)}>
                <Grid item xs={3}>
                  <TextField
                    id="newPassword"
                    margin="normal"
                    fullWidth
                    type="password"
                    placeholder={'New Password'}
                    {...register('password')}
                    style={{ width: 302 }}
                    onChange={(e) => {
                      setpasswordError('');
                      setValue('password', e.target.value);
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Lock />
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
                <Typography
                  style={{
                    fontSize: '11px',
                    width: '300px'
                  }}
                  color="red"
                >
                    {passwordError}&nbsp;
                </Typography>
                <Grid item xs={3}>
                  <TextField
                    id="confirmPassword"
                    margin="normal"
                    fullWidth
                    type="password"
                    placeholder={'Confirm Password'}
                    {...register('conformedPassword')}
                    style={{ width: 302 }}
                    onChange={(e) => {
                      setConfirmPasswordError('')
                      setValue('conformedPassword', e.target.value);
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Lock />
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
                <Typography
                  style={{
                    fontSize: '11px',
                    width: '300px'
                  }}
                  color="red"
                >
                  {confirmPasswordError}&nbsp;
                </Typography>
                <Grid item xs={3}>
                  <Button
                    id="btn-changePassword"
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    style={{ width: 302 }}
                    className={isLoading ? 'loading' : ''}
                  >
                    Change Password
                  </Button>
                </Grid>
              </form>
            </Grid>
          </Box>
        </Box>
      </Grid>
      <SnackBar />
    </Grid>
  );
};
